import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';

const Highlights = asyncComponent(() =>
  import('../../containers/authorised/organisation/Highlights')
);
const Integration = asyncComponent(() =>
  import('../../containers/authorised/organisation/Integration')
);
const Stores = asyncComponent(() =>
  import('../../containers/authorised/organisation/store/Stores.js')
);
const Staff = asyncComponent(() =>
  import('../../containers/authorised/organisation/staff/Staffs.js')
)
const StorePrevileges = asyncComponent(() =>
  import('../../containers/authorised/organisation/staff/staffStorePermission/StorePrevileges')
)
const PerDaySchedule = asyncComponent(() =>
  import('../../containers/authorised/organisation/staff/staffSchedule/PerDaySchedule')
)
const AnonymousSchedule = asyncComponent(() =>
  import('../../containers/authorised/organisation/staff/staffSchedule/AnonymousSchedule')
)
const Schedule = asyncComponent(() =>
  import('../../containers/authorised/organisation/store/storeSchedule/PerDaySchedule')
)
const StaffTransfer = asyncComponent(() =>
  import('../../containers/authorised/organisation/staff/staffTransfer/StaffTransfer.js')
)

const OrganisationRoutes = (
  <Switch>
    <Route exact path="/organisation/highlights" component={Highlights} />
    <Route exact path="/organisation/stores" component={Stores} />
    <Route exact path="/organisation/staff" component={Staff} />
    <Route exact path="/organisation/transfer-staff" component={StaffTransfer} />
    <Route exact path="/organisation/integration" component={Integration} />
    <Redirect exact from="/organisation" to="/organisation/highlights" />

    <Route exact path="/organisation/stores/:id/staff" component={Staff} />
    <Route exact path="/organisation/stores/:id/schedule" component={Schedule} />
    <Route exact path="/organisation/staffs/:id/store-privileges" component={StorePrevileges} />
    <Route exact path="/organisation/staffs/:id/schedule" component={PerDaySchedule} />
    <Route exact path="/organisation/staffs/:id/anonymous-schedule" component={AnonymousSchedule} />
  </Switch>
);

export default OrganisationRoutes;